import { useState } from "react";
import { ImageSize, ImageOwnerType } from "app-constants";

interface ImageProps {
    imageOwnerType: ImageOwnerType;
    imageSize: ImageSize;
    imageId: string | null;
    title?: string;
    className?: string;
  }

const Image: React.FC<ImageProps> = ({ imageOwnerType, imageSize, imageId, title, className }) => {
    const [imageSrc, setImageSrc] = useState(`/image/${imageOwnerType}/${imageId}/${imageSize}.webp`);

    const handleError = () => {
        setImageSrc('/images/missing-' + imageOwnerType.toLowerCase() + '-' + imageSize.toLowerCase() + '.webp');
    };

    return (
        <img src={imageSrc} onError={handleError} title={title || ''} alt={title || ''} className={className} />
    );
};

export default Image;